<template>
  <div class="bg-white rounded-xl shadow-lg p-6">
    <h2 class="text-2xl font-bold text-gray-900 mb-6 flex items-center gap-2">
      <span>🔄</span>
      Embudo de Producción
    </h2>

    <!-- Etapas del Embudo -->
    <div class="space-y-4 mb-8">
      <div
        v-for="etapa in embudo.etapas"
        :key="etapa.orden"
        class="relative"
      >
        <div class="flex items-center gap-4">
          <!-- Icono y orden -->
          <div class="flex-shrink-0 w-12 h-12 rounded-full flex items-center justify-center font-bold text-white text-lg"
               :style="`background-color: ${etapa.color}`">
            {{ etapa.orden }}
          </div>
          
          <!-- Barra de progreso -->
          <div class="flex-1">
            <div class="flex justify-between items-center mb-1">
              <span class="font-semibold text-gray-900">{{ etapa.nombre }}</span>
              <span class="text-sm text-gray-600">
                {{ etapa.cantidad }} ({{ etapa.porcentaje.toFixed(1) }}%)
              </span>
            </div>
            <div class="w-full bg-gray-200 rounded-full h-6 relative overflow-hidden">
              <div 
                class="h-6 rounded-full transition-all duration-700 flex items-center justify-end pr-2"
                :style="`width: ${etapa.porcentaje}%; background-color: ${etapa.color}`"
              >
                <span class="text-white text-xs font-semibold">{{ etapa.porcentaje.toFixed(0) }}%</span>
              </div>
            </div>
          </div>
          
          <!-- Icono de la etapa -->
          <div class="flex-shrink-0 text-2xl opacity-60">
            {{ getIconoEtapa(etapa.icono) }}
          </div>
        </div>
      </div>
    </div>

    <!-- Tasas de Conversión -->
    <div class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4 mb-6">
      <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>📊</span>
        Tasas de Conversión
      </h3>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div class="bg-white rounded-lg p-3">
          <p class="text-sm text-gray-600 mb-1">Venta → Formato</p>
          <p class="text-2xl font-bold text-blue-600">{{ embudo.tasas_conversion.venta_a_formato.toFixed(1) }}%</p>
        </div>
        <div class="bg-white rounded-lg p-3">
          <p class="text-sm text-gray-600 mb-1">Formato → Producción</p>
          <p class="text-2xl font-bold text-purple-600">{{ embudo.tasas_conversion.formato_a_produccion.toFixed(1) }}%</p>
        </div>
        <div class="bg-white rounded-lg p-3">
          <p class="text-sm text-gray-600 mb-1">Producción → Instalación</p>
          <p class="text-2xl font-bold text-green-600">{{ embudo.tasas_conversion.produccion_a_instalacion.toFixed(1) }}%</p>
        </div>
      </div>
    </div>

    <!-- Cuellos de Botella -->
    <div v-if="embudo.cuellos_botella && embudo.cuellos_botella.length > 0">
      <h3 class="font-semibold text-gray-900 mb-3 flex items-center gap-2">
        <span>⚠️</span>
        Cuellos de Botella Detectados
      </h3>
      <div class="space-y-3">
        <div
          v-for="(cuello, index) in embudo.cuellos_botella"
          :key="index"
          :class="getSeveridadClass(cuello.severidad)"
          class="p-4 rounded-lg border-l-4"
        >
          <div class="flex items-center justify-between">
            <div>
              <p class="font-semibold text-gray-900">{{ cuello.etapa }}</p>
              <p class="text-sm text-gray-600 mt-1">
                Pérdida: {{ cuello.cantidad_perdida }} unidades ({{ cuello.porcentaje_perdida.toFixed(1) }}%)
              </p>
            </div>
            <span :class="getSeveridadBadgeClass(cuello.severidad)" class="px-3 py-1 rounded-full text-sm font-semibold">
              {{ cuello.severidad }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmbudoProduccion',
  props: {
    embudo: {
      type: Object,
      required: true
    }
  },
  methods: {
    getIconoEtapa(nombre) {
      const iconos = {
        'shopping-cart': '🛒',
        'printer': '🖨️',
        'check-circle': '✅',
        'cog': '⚙️',
        'package': '📦',
        'check-double': '✔️✔️'
      };
      return iconos[nombre] || '📌';
    },
    getSeveridadClass(severidad) {
      switch (severidad) {
        case 'CRITICA':
          return 'bg-red-50 border-red-500';
        case 'ALTA':
          return 'bg-orange-50 border-orange-500';
        case 'MEDIA':
          return 'bg-yellow-50 border-yellow-500';
        case 'BAJA':
          return 'bg-green-50 border-green-500';
        default:
          return 'bg-gray-50 border-gray-300';
      }
    },
    getSeveridadBadgeClass(severidad) {
      switch (severidad) {
        case 'CRITICA':
          return 'bg-red-100 text-red-800';
        case 'ALTA':
          return 'bg-orange-100 text-orange-800';
        case 'MEDIA':
          return 'bg-yellow-100 text-yellow-800';
        case 'BAJA':
          return 'bg-green-100 text-green-800';
        default:
          return 'bg-gray-100 text-gray-800';
      }
    }
  }
};
</script>
